<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-3">
    <div :class="'p-3 flex content-main pb-[60px]' + (action.component ? ' half-it gap-5' : 'gap-5')">
      
      <div class="custom-full">
        <template v-if="vg_selectedLocation.id">
          <Nav/>
          <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
            <div class="flex justify-between mt-5 h-[40px]">
              <h2 class="text-[24px] font-semibold text-white">POS Stations</h2>
              <mdicon @click="addUpdate({ component: 'Add', data: {}})" v-if="!action.component" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
            </div>
            <List :selectedItemCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/>
          </div>
        </template>

        <div v-else class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">
          <p class="text-center text-theme-red mt-3">Please select a location from the top left corner.</p>
        </div>
      </div>

       <div :class="'w-full hidden-component'" v-if="action.component" >
        <component :is="action.component" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Nav from '@/views/Location/Devices/Nav.vue';
import List from '@/views/Location/Devices/Pos/List.vue';
import Add from '@/views/Location/Devices/Pos/Add.vue';
import Update from '@/views/Location/Devices/Pos/Update.vue';


  export default defineComponent({
  name: "LocationDevicesPos",
  components: {
   Nav,
   List,
   Add,
   Update
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    return {
      action,
    };
  },

   watch: {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {
    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  mounted() {
   
  },

  beforeDestroy() {
   this.emitter.all.clear();
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>

